import { create } from "zustand"
import { membersApi, memberInvitationsApi } from "../services/axiosServices"

const initialPageInfo = {
  totalElements: 0,
  totalPages: 0,
  number: 0,
  size: 10,
  first: true,
  last: true,
  empty: true,
  numberOfElements: 0,
}

const initialState = {
  members: [],
  invitations: [],
  loading: false,
  error: null,
  pageInfo: initialPageInfo,
}

const toPageInfo = (data, params) => ({
  totalElements: data?.totalElements ?? 0,
  totalPages: data?.totalPages ?? 0,
  number: data?.number ?? 0,
  size: data?.size ?? params.size ?? initialPageInfo.size,
  first: data?.first ?? true,
  last: data?.last ?? true,
  empty: data?.empty ?? true,
  numberOfElements: data?.numberOfElements ?? 0,
})

export const membersStore = create((set, get) => ({
  ...initialState,

  getMembers: async (params = {}) => {
    // Guard against duplicate in-flight requests (e.g. StrictMode double
    // effects), mirroring organizationStore's getOrganizations.
    if (get().loading) return null

    set({ loading: true, error: null })
    try {
      const res = await membersApi(params)
      const data = res?.data?.data

      set({
        members: data?.content ?? [],
        pageInfo: toPageInfo(data, params),
        loading: false,
      })

      return data
    } catch (err) {
      console.error("Failed to load members:", err)
      set({
        error: "Failed to load members. Please try again.",
        loading: false,
      })
      return null
    }
  },

  getInvitations: async (params = {}) => {
    if (get().loading) return null

    set({ loading: true, error: null })
    try {
      const res = await memberInvitationsApi(params)
      const data = res?.data?.data

      set({
        invitations: data?.content ?? [],
        pageInfo: toPageInfo(data, params),
        loading: false,
      })

      return data
    } catch (err) {
      console.error("Failed to load invitations:", err)
      set({
        error: "Failed to load invitations. Please try again.",
        loading: false,
      })
      return null
    }
  },

  reset: () =>
    set({
      members: [],
      invitations: [],
      loading: false,
      error: null,
      pageInfo: initialPageInfo,
    }),
}))
